var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconButtonRegular(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 150,
    viewBox: "0 0 200 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5133_239410)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 150,
    fill: "#F7F8F8"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_5133_239410)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 150,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.5,
    y: 58.5,
    width: 39,
    height: 39,
    stroke: "#FF1844",
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.71 71.63C61.1 72.02 61.1 72.65 60.71 73.04L58.88 74.87L55.13 71.12L56.96 69.29C57.35 68.9 57.98 68.9 58.37 69.29L60.71 71.63ZM43 87V83.25L54.06 72.19L57.81 75.94L46.75 87H43Z",
    fill: "#727E84"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 66.5,
    width: 23,
    height: 23,
    stroke: "#2A7AFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.5 70H107V72H93V70H96.5L97.5 69H102.5L103.5 70ZM96 87C94.9 87 94 86.1 94 85V73H106V85C106 86.1 105.1 87 104 87H96Z",
    fill: "#727E84"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.5,
    y: 66.5,
    width: 23,
    height: 23,
    stroke: "#2A7AFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148 74C149.1 74 150 73.1 150 72C150 70.9 149.1 70 148 70C146.9 70 146 70.9 146 72C146 73.1 146.9 74 148 74ZM148 76C146.9 76 146 76.9 146 78C146 79.1 146.9 80 148 80C149.1 80 150 79.1 150 78C150 76.9 149.1 76 148 76ZM146 84C146 82.9 146.9 82 148 82C149.1 82 150 82.9 150 84C150 85.1 149.1 86 148 86C146.9 86 146 85.1 146 84Z",
    fill: "#727E84"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.5,
    y: 66.5,
    width: 23,
    height: 23,
    stroke: "#2A7AFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 64.5,
    y1: 110,
    x2: 64.5,
    y2: 90,
    stroke: "#01BFA5",
    strokeDasharray: "1 1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.5,
    y1: 110,
    x2: 87.5,
    y2: 90,
    stroke: "#01BFA5",
    strokeDasharray: "1 1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 64,
    y1: 99.5,
    x2: 88,
    y2: 99.5,
    stroke: "#01BFA5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160.5,
    y1: 110,
    x2: 160.5,
    y2: 90,
    stroke: "#01BFA5",
    strokeDasharray: "1 1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175.5,
    y1: 110,
    x2: 175.5,
    y2: 90,
    stroke: "#01BFA5",
    strokeDasharray: "1 1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 99.5,
    x2: 176,
    y2: 99.5,
    stroke: "#01BFA5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 18,
    transform: "translate(42 44)",
    fill: "#2A7AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3486 58H44.8271V57.0908L48.2725 53.2627C48.7829 52.6839 49.1338 52.2145 49.3252 51.8545C49.5212 51.4899 49.6191 51.1139 49.6191 50.7266C49.6191 50.207 49.4619 49.7809 49.1475 49.4482C48.833 49.1156 48.4137 48.9492 47.8896 48.9492C47.2607 48.9492 46.7708 49.1292 46.4199 49.4893C46.0736 49.8447 45.9004 50.3415 45.9004 50.9795H44.6357C44.6357 50.0635 44.9297 49.3229 45.5176 48.7578C46.11 48.1927 46.9007 47.9102 47.8896 47.9102C48.8148 47.9102 49.5462 48.154 50.084 48.6416C50.6217 49.1247 50.8906 49.7695 50.8906 50.5762C50.8906 51.556 50.2663 52.7227 49.0176 54.0762L46.3516 56.9678H51.3486V58ZM58.0273 54.6572H59.4082V55.6895H58.0273V58H56.7559V55.6895H52.2236V54.9443L56.6807 48.0469H58.0273V54.6572ZM53.6592 54.6572H56.7559V49.7764L56.6055 50.0498L53.6592 54.6572Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 18,
    transform: "translate(90 44)",
    fill: "#2A7AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3486 58H92.8271V57.0908L96.2725 53.2627C96.7829 52.6839 97.1338 52.2145 97.3252 51.8545C97.5212 51.4899 97.6191 51.1139 97.6191 50.7266C97.6191 50.207 97.4619 49.7809 97.1475 49.4482C96.833 49.1156 96.4137 48.9492 95.8896 48.9492C95.2607 48.9492 94.7708 49.1292 94.4199 49.4893C94.0736 49.8447 93.9004 50.3415 93.9004 50.9795H92.6357C92.6357 50.0635 92.9297 49.3229 93.5176 48.7578C94.11 48.1927 94.9007 47.9102 95.8896 47.9102C96.8148 47.9102 97.5462 48.154 98.084 48.6416C98.6217 49.1247 98.8906 49.7695 98.8906 50.5762C98.8906 51.556 98.2663 52.7227 97.0176 54.0762L94.3516 56.9678H99.3486V58ZM106.027 54.6572H107.408V55.6895H106.027V58H104.756V55.6895H100.224V54.9443L104.681 48.0469H106.027V54.6572ZM101.659 54.6572H104.756V49.7764L104.605 50.0498L101.659 54.6572Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 18,
    transform: "translate(138 44)",
    fill: "#2A7AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.349 58H140.827V57.0908L144.272 53.2627C144.783 52.6839 145.134 52.2145 145.325 51.8545C145.521 51.4899 145.619 51.1139 145.619 50.7266C145.619 50.207 145.462 49.7809 145.147 49.4482C144.833 49.1156 144.414 48.9492 143.89 48.9492C143.261 48.9492 142.771 49.1292 142.42 49.4893C142.074 49.8447 141.9 50.3415 141.9 50.9795H140.636C140.636 50.0635 140.93 49.3229 141.518 48.7578C142.11 48.1927 142.901 47.9102 143.89 47.9102C144.815 47.9102 145.546 48.154 146.084 48.6416C146.622 49.1247 146.891 49.7695 146.891 50.5762C146.891 51.556 146.266 52.7227 145.018 54.0762L142.352 56.9678H147.349V58ZM154.027 54.6572H155.408V55.6895H154.027V58H152.756V55.6895H148.224V54.9443L152.681 48.0469H154.027V54.6572ZM149.659 54.6572H152.756V49.7764L152.605 50.0498L149.659 54.6572Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 18,
    transform: "translate(66 112)",
    fill: "#01BFA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3486 126H68.8271V125.091L72.2725 121.263C72.7829 120.684 73.1338 120.215 73.3252 119.854C73.5212 119.49 73.6191 119.114 73.6191 118.727C73.6191 118.207 73.4619 117.781 73.1475 117.448C72.833 117.116 72.4137 116.949 71.8896 116.949C71.2607 116.949 70.7708 117.129 70.4199 117.489C70.0736 117.845 69.9004 118.341 69.9004 118.979H68.6357C68.6357 118.063 68.9297 117.323 69.5176 116.758C70.11 116.193 70.9007 115.91 71.8896 115.91C72.8148 115.91 73.5462 116.154 74.084 116.642C74.6217 117.125 74.8906 117.77 74.8906 118.576C74.8906 119.556 74.2663 120.723 73.0176 122.076L70.3516 124.968H75.3486V126ZM82.0273 122.657H83.4082V123.689H82.0273V126H80.7559V123.689H76.2236V122.944L80.6807 116.047H82.0273V122.657ZM77.6592 122.657H80.7559V117.776L80.6055 118.05L77.6592 122.657Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 18,
    transform: "translate(158 112)",
    fill: "#01BFA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.983 126H163.712V117.571L161.162 118.508V117.359L164.785 115.999H164.983V126ZM173.651 116.04V117.113H173.419C172.435 117.132 171.651 117.423 171.067 117.988C170.484 118.553 170.147 119.349 170.056 120.374C170.58 119.772 171.295 119.472 172.202 119.472C173.068 119.472 173.758 119.777 174.273 120.388C174.793 120.998 175.053 121.787 175.053 122.753C175.053 123.778 174.772 124.599 174.212 125.214C173.656 125.829 172.909 126.137 171.97 126.137C171.017 126.137 170.245 125.772 169.652 125.043C169.06 124.309 168.764 123.366 168.764 122.213V121.728C168.764 119.896 169.153 118.496 169.933 117.53C170.716 116.56 171.881 116.063 173.426 116.04H173.651ZM171.99 120.524C171.557 120.524 171.159 120.654 170.794 120.914C170.429 121.174 170.176 121.5 170.035 121.892V122.356C170.035 123.177 170.22 123.838 170.589 124.339C170.958 124.84 171.418 125.091 171.97 125.091C172.539 125.091 172.986 124.881 173.31 124.462C173.638 124.043 173.802 123.493 173.802 122.814C173.802 122.131 173.635 121.579 173.303 121.16C172.975 120.736 172.537 120.524 171.99 120.524Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_5133_239410",
    x: -10,
    y: -9,
    width: 196,
    height: 170,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5133_239410"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5133_239410",
    result: "effect2_dropShadow_5133_239410"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect3_dropShadow_5133_239410"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_5133_239410",
    result: "effect3_dropShadow_5133_239410"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_5133_239410",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5133_239410"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 150,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconButtonRegular);
export default __webpack_public_path__ + "static/media/icon-button-regular.81b1cbe62d89f5ffd972ea34461e6e4a.svg";
export { ForwardRef as ReactComponent };